'use client';

import {
  Avatar,
  Logo,
  NavButton,
  NavContent,
  NavEnd,
  NavIconButton,
  NavRoot,
  NavStart,
  SheetBody,
  SheetClose,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetHeading,
  SheetRoot,
  SheetTrigger,
  Stack,
  StackItem,
  Text,
} from '@pie/amber';
import {
  IconBookOpenText,
  IconClipboardPlus,
  IconHeadset,
  IconHouse,
  IconLogOut,
  IconMenu,
  IconReceipt,
  IconUser,
} from '@pie/amber-icons';
import { SENSITIVE_CLASS_NAME } from '@upms/analytics';
import NextLink from 'next/link';
import { env } from '@/config/env';
import { fullName, useIdentityContext } from '../IdentityContext';
import { useAuthContext } from '../AuthContext';

export const MobileNavigation = () => {
  const { clearSession } = useAuthContext();
  const { user } = useIdentityContext();

  return (
    <NavRoot size="mobile">
      <NavContent>
        {/* TODO(EE-419): Replace Logo with proper NavStart content */}
        <NavStart>
          <Logo size="sm" />
        </NavStart>
        <NavEnd>
          <SheetRoot>
            <SheetTrigger>
              <NavIconButton label="Mobile Navigation Menu">
                <IconMenu />
              </NavIconButton>
            </SheetTrigger>
            <SheetContent>
              <SheetHeader>
                <Stack className="min-w-0" direction="row" gap="2xs">
                  <StackItem className="min-w-0" grow>
                    <SheetHeading as="div">
                      <Stack direction="row" gap="sm">
                        <StackItem>
                          <Avatar decorative icon={<IconUser />} />
                        </StackItem>
                        <StackItem className={`min-w-0 ${SENSITIVE_CLASS_NAME}`}>
                          <Text className="truncate">{fullName(user)}</Text>
                          <Text className="truncate" emphasis="subtle" variant="body-sm">
                            {user.email}
                          </Text>
                        </StackItem>
                      </Stack>
                    </SheetHeading>
                  </StackItem>
                  <StackItem self="start">
                    <SheetClose label="Close Mobile Navigation" />
                  </StackItem>
                </Stack>
              </SheetHeader>
              <SheetBody>
                <Stack gap="2xs">
                  <SheetClose>
                    <NavButton as={NextLink} href="/" startIcon={<IconHouse />}>
                      Home
                    </NavButton>
                  </SheetClose>
                  <SheetClose>
                    <NavButton as={NextLink} href="/billing" startIcon={<IconReceipt />}>
                      Billing and Payments
                    </NavButton>
                  </SheetClose>
                  <SheetClose>
                    <NavButton as={NextLink} href="/resources" startIcon={<IconBookOpenText />}>
                      Resources
                    </NavButton>
                  </SheetClose>
                  <SheetClose>
                    <NavButton as={NextLink} href="/support" startIcon={<IconHeadset />}>
                      Help and Support
                    </NavButton>
                  </SheetClose>
                  <SheetClose>
                    <NavButton
                      as="a"
                      href={env.NEXT_PUBLIC_FILE_CLAIM_URL}
                      rel="noopener noreferrer"
                      startIcon={<IconClipboardPlus />}
                      target="_blank"
                    >
                      File a Claim
                    </NavButton>
                  </SheetClose>
                </Stack>
              </SheetBody>
              <SheetFooter>
                <NavButton
                  onClick={() => {
                    clearSession();
                  }}
                  startIcon={<IconLogOut />}
                >
                  Sign out
                </NavButton>
              </SheetFooter>
            </SheetContent>
          </SheetRoot>
        </NavEnd>
      </NavContent>
    </NavRoot>
  );
};
